module.exports = __webpack_public_path__ + "img/onboarding-step-2.465b6088.png";